import Image from "next/image";
import { twJoin } from "tailwind-merge";

import styles from "./MeowWolf.module.scss";

const MeowWolfConclusionBackground = () => {
  return (
    <div
      id="meowwolf-conclusion-background"
      className="absolute w-full h-full overflow-visible top-0 left-1/2 translate-x-[-50%]"
    >
      <div
        className={twJoin(
          styles["meowwolf-conclusion-background-one"],
          "absolute top-1/2 left-1/2 translate-x-[-37%] translate-y-[-118%] md:translate-x-[-32%] md:translate-y-[-94%] scale-x-[-1] w-[1001px] h-[1122px]"
        )}
      ></div>
      <Image
        className="absolute top-1/2 left-1/2 translate-x-[-44%] translate-y-[-12%] md:translate-x-[-50%] md:translate-y-[-56%] w-[451px] h-[530px] md:w-[1203px] md:h-[1412px] max-w-none"
        src="/images/projects/meowwolf/meowwolf-conclusion-grid.png"
        alt=""
        height="1330"
        width="1334"
        quality={100}
        priority
        role="presentation"
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 1360 872"
        fill="none"
        className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[43%]  md:translate-x-[-50%] md:translate-y-[-26%] w-[532px] h-[325px] md:w-[1424px] md:h-[872px]"
      >
        <g clipPath="url(#clip0_28_4726)">
          <path
            opacity="0.59"
            d="M986 224C980.477 224 976 228.477 976 234C976 239.523 980.477 244 986 244C991.523 244 996 239.523 996 234C996 228.477 991.523 224 986 224Z"
            fill="url(#paint0_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M361 741C364.314 741 367 738.09 367 734.5C367 730.91 364.314 728 361 728C357.686 728 355 730.91 355 734.5C355 738.09 357.686 741 361 741Z"
            fill="url(#paint1_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M1032 870C1026.48 870 1022 874.477 1022 880C1022 885.523 1026.48 890 1032 890C1037.52 890 1042 885.523 1042 880C1042 874.477 1037.52 870 1032 870Z"
            fill="url(#paint2_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M776 526C781.523 526 786 521.523 786 516C786 510.477 781.523 506 776 506C770.477 506 766 510.477 766 516C766 521.523 770.477 526 776 526Z"
            fill="url(#paint3_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M1232 464C1226.48 464 1222 468.477 1222 474C1222 479.523 1226.48 484 1232 484C1237.52 484 1242 479.523 1242 474C1242 468.477 1237.52 464 1232 464Z"
            fill="url(#paint4_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M1133 373C1127.48 373 1123 377.477 1123 383C1123 388.523 1127.48 393 1133 393C1138.52 393 1143 388.523 1143 383C1143 377.477 1138.52 373 1133 373Z"
            fill="url(#paint5_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M1080 829C1076.69 829 1074 831.686 1074 835C1074 838.314 1076.69 841 1080 841C1083.31 841 1086 838.314 1086 835C1086 831.686 1083.31 829 1080 829Z"
            fill="url(#paint6_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M728 567C731.314 567 734 564.314 734 561C734 557.686 731.314 555 728 555C724.686 555 722 557.686 722 561C722 564.314 724.686 567 728 567Z"
            fill="url(#paint7_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M1131 867C1129.34 867 1128 868.343 1128 870C1128 871.657 1129.34 873 1131 873C1132.66 873 1134 871.657 1134 870C1134 868.343 1132.66 867 1131 867Z"
            fill="url(#paint8_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M677 529C678.657 529 680 527.657 680 526C680 524.343 678.657 523 677 523C675.343 523 674 524.343 674 526C674 527.657 675.343 529 677 529Z"
            fill="url(#paint9_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M407 741C408.657 741 410 739.657 410 738C410 736.343 408.657 735 407 735C405.343 735 404 736.343 404 738C404 739.657 405.343 741 407 741Z"
            fill="url(#paint10_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M1170 645C1168.34 645 1167 646.343 1167 648C1167 649.657 1168.34 651 1170 651C1171.66 651 1173 649.657 1173 648C1173 646.343 1171.66 645 1170 645Z"
            fill="url(#paint11_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M638 751C639.657 751 641 749.657 641 748C641 746.343 639.657 745 638 745C636.343 745 635 746.343 635 748C635 749.657 636.343 751 638 751Z"
            fill="url(#paint12_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M980 458C976.686 458 974 460.686 974 464C974 467.314 976.686 470 980 470C983.314 470 986 467.314 986 464C986 460.686 983.314 458 980 458Z"
            fill="url(#paint13_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M1029 513C1027.34 513 1026 514.343 1026 516C1026 517.657 1027.34 519 1029 519C1030.66 519 1032 517.657 1032 516C1032 514.343 1030.66 513 1029 513Z"
            fill="url(#paint14_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M1268 645C1266.34 645 1265 646.343 1265 648C1265 649.657 1266.34 651 1268 651C1269.66 651 1271 649.657 1271 648C1271 646.343 1269.66 645 1268 645Z"
            fill="url(#paint15_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M540 751C541.657 751 543 749.657 543 748C543 746.343 541.657 745 540 745C538.343 745 537 746.343 537 748C537 749.657 538.343 751 540 751Z"
            fill="url(#paint16_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M400 692C401.657 692 403 690.657 403 689C403 687.343 401.657 686 400 686C398.343 686 397 687.343 397 689C397 690.657 398.343 692 400 692Z"
            fill="url(#paint17_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M358 774C359.657 774 361 772.657 361 771C361 769.343 359.657 768 358 768C356.343 768 355 769.343 355 771C355 772.657 356.343 774 358 774Z"
            fill="url(#paint18_radial_28_4726)"
          />
          <path
            opacity="0.19"
            d="M1029 638C1027.34 638 1026 639.343 1026 641C1026 642.657 1027.34 644 1029 644C1030.66 644 1032 642.657 1032 641C1032 639.343 1030.66 638 1029 638Z"
            fill="url(#paint19_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M779 758C780.657 758 782 756.657 782 755C782 753.343 780.657 752 779 752C777.343 752 776 753.343 776 755C776 756.657 777.343 758 779 758Z"
            fill="url(#paint20_radial_28_4726)"
          />
          <path
            opacity="0.19"
            d="M1038 613C1036.34 613 1035 614.343 1035 616C1035 617.657 1036.34 619 1038 619C1039.66 619 1041 617.657 1041 616C1041 614.343 1039.66 613 1038 613Z"
            fill="url(#paint21_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M770 783C771.657 783 773 781.657 773 780C773 778.343 771.657 777 770 777C768.343 777 767 778.343 767 780C767 781.657 768.343 783 770 783Z"
            fill="url(#paint22_radial_28_4726)"
          />
          <path
            opacity="0.2"
            d="M347.5 447C353.299 447 358 442.523 358 437C358 431.477 353.299 427 347.5 427C341.701 427 337 431.477 337 437C337 442.523 341.701 447 347.5 447Z"
            fill="url(#paint23_radial_28_4726)"
          />
          <path
            opacity="0.59"
            d="M79.8436 715.495C79.8436 705.474 87.9664 697.351 97.9866 697.351C108.007 697.351 116.13 705.474 116.13 715.495C116.13 725.515 108.007 733.638 97.9866 733.638C87.9664 733.638 79.8436 725.515 79.8436 715.495Z"
            fill="url(#paint24_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M105.303 598.024C105.303 592.039 110.155 587.187 116.139 587.187C122.124 587.187 126.976 592.039 126.976 598.024C126.976 604.009 122.124 608.86 116.139 608.86C110.155 608.86 105.303 604.009 105.303 598.024Z"
            fill="url(#paint25_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M771.134 714.833C771.134 708.848 775.986 703.997 781.971 703.997C787.955 703.997 792.807 708.848 792.807 714.833C792.807 720.818 787.955 725.67 781.971 725.67C775.986 725.67 771.134 720.818 771.134 714.833Z"
            fill="url(#paint26_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M204.637 685.861C204.637 682.869 207.063 680.443 210.055 680.443C213.048 680.443 215.474 682.869 215.474 685.861C215.474 688.853 213.048 691.279 210.055 691.279C207.063 691.279 204.637 688.853 204.637 685.861Z"
            fill="url(#paint27_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M425.856 328.235C425.856 318.215 433.979 310.092 443.999 310.092C454.02 310.092 462.143 318.215 462.143 328.235C462.143 338.255 454.02 346.378 443.999 346.378C433.979 346.378 425.856 338.255 425.856 328.235Z"
            fill="url(#paint28_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M262.955 150.745C262.955 140.725 271.078 132.602 281.099 132.602C291.119 132.602 299.242 140.725 299.242 150.745C299.242 160.766 291.119 168.889 281.099 168.889C271.078 168.889 262.955 160.766 262.955 150.745Z"
            fill="url(#paint29_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M1083.87 55.3655C1083.87 49.3806 1088.72 44.5288 1094.7 44.5288C1100.69 44.5288 1105.54 49.3806 1105.54 55.3655C1105.54 61.3504 1100.69 66.2021 1094.7 66.2021C1088.72 66.2021 1083.87 61.3504 1083.87 55.3655Z"
            fill="url(#paint30_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M1151.76 146.328C1151.76 143.335 1154.19 140.909 1157.18 140.909C1160.18 140.909 1162.6 143.335 1162.6 146.328C1162.6 149.32 1160.18 151.746 1157.18 151.746C1154.19 151.746 1151.76 149.32 1151.76 146.328Z"
            fill="url(#paint31_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M769.814 632.722C769.814 629.73 772.24 627.304 775.232 627.304C778.225 627.304 780.65 629.73 780.65 632.722C780.65 635.715 778.225 638.141 775.232 638.141C772.24 638.141 769.814 635.715 769.814 632.722Z"
            fill="url(#paint32_radial_28_4726)"
          />
          <path
            opacity="0.33"
            d="M752.794 216.961C752.794 213.968 755.22 211.542 758.213 211.542C761.205 211.542 763.631 213.968 763.631 216.961C763.631 219.953 761.205 222.379 758.213 222.379C755.22 222.379 752.794 219.953 752.794 216.961Z"
            fill="url(#paint33_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M752.794 392.018C752.794 389.026 755.22 386.6 758.213 386.6C761.205 386.6 763.631 389.026 763.631 392.018C763.631 395.011 761.205 397.437 758.213 397.437C755.22 397.437 752.794 395.011 752.794 392.018Z"
            fill="url(#paint34_radial_28_4726)"
          />
          <path
            opacity="0.54"
            d="M858.786 644.243C858.786 641.25 861.212 638.824 864.205 638.824C867.197 638.824 869.623 641.25 869.623 644.243C869.623 647.235 867.197 649.661 864.205 649.661C861.212 649.661 858.786 647.235 858.786 644.243Z"
            fill="url(#paint35_radial_28_4726)"
          />
          <path
            opacity="0.19"
            d="M711.499 720.917C711.499 717.924 713.925 715.498 716.918 715.498C719.91 715.498 722.336 717.924 722.336 720.917C722.336 723.909 719.91 726.335 716.918 726.335C713.925 726.335 711.499 723.909 711.499 720.917Z"
            fill="url(#paint36_radial_28_4726)"
          />
          <path
            opacity="0.42"
            d="M1299 739.143C1299 729.123 1307.12 721 1317.14 721C1327.16 721 1335.29 729.123 1335.29 739.143C1335.29 749.163 1327.16 757.286 1317.14 757.286C1307.12 757.286 1299 749.163 1299 739.143Z"
            fill="url(#paint37_radial_28_4726)"
          />
        </g>
        <defs>
          <pattern
            id="pattern0_28_4726"
            patternContentUnits="objectBoundingBox"
            width={1}
            height={1}
          >
            <use
              xlinkHref="#image0_28_4726"
              transform="matrix(0.00176991 0 0 0.00588235 -0.0673245 -0.235294)"
            />
          </pattern>
          <radialGradient
            id="paint0_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(985.979 233.982) rotate(180) scale(9.99335 9.99335)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint1_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(360.988 734.506) scale(5.98491 6.48365)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint2_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1032.11 879.997) rotate(-33.9189) scale(9.99301)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint3_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(775.886 516.003) rotate(146.081) scale(9.99301)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint4_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1232.11 473.997) rotate(-33.9189) scale(9.99301)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint5_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1133.11 382.997) rotate(-33.9189) scale(9.99301)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint6_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1080.11 835.02) rotate(-33.9189) scale(5.98471)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint7_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(727.895 560.98) rotate(146.081) scale(5.98471)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint8_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1131.13 870) rotate(-33.9189) scale(2.99235)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint9_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(676.872 526) rotate(146.081) scale(2.99235)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint10_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(406.872 738) rotate(146.081) scale(2.99235)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint11_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1170.13 648) rotate(-33.9189) scale(2.99235)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint12_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(637.872 748) rotate(146.081) scale(2.99235)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint13_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(979.994 464.017) rotate(180) scale(5.98491)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint14_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1028.98 515.996) rotate(180) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint15_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1267.98 647.996) rotate(180) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint16_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(540.016 748.004) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint17_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(399.999 688.996) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint18_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(358.018 771.012) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint19_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1028.98 640.995) rotate(180) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint20_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(779.016 755.005) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint21_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1038 616.014) rotate(180) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint22_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(770.003 779.986) scale(2.99245)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint23_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(347.4 437.021) rotate(147.363) scale(10.3397 10.1409)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint24_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(97.9889 715.475) rotate(-90) scale(18.1311 18.1311)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint25_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(116.129 598.046) rotate(-90) scale(10.8094 10.8093)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint26_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(781.961 714.856) rotate(-90) scale(10.8094 10.8093)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint27_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(210.088 685.865) rotate(-90) scale(5.4047 5.40472)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint28_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(443.993 328.442) rotate(123.919) scale(18.1305 18.1305)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint29_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(281.092 150.953) rotate(123.919) scale(18.1305 18.1305)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint30_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1094.74 55.5553) rotate(123.919) scale(10.809)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint31_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1157.18 146.559) rotate(123.919) scale(5.40451)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint32_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(775.232 632.953) rotate(123.919) scale(5.40451)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint33_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(758.212 217.192) rotate(123.919) scale(5.40451)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint34_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(758.205 391.989) rotate(-90) scale(5.4047 5.40472)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint35_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(864.212 644.245) rotate(-90) scale(5.40469 5.40467)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint36_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(716.895 720.883) rotate(-90) scale(5.4047 5.40467)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint37_radial_28_4726"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1317.11 739.316) rotate(123.919) scale(18.1305 18.1305)"
          >
            <stop stopColor="#FBFAFC" />
            <stop offset={1} stopColor="#F4F5F8" stopOpacity={0} />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};

export default MeowWolfConclusionBackground;
